import React from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import "./PageHeader.css";

import { toggleSidebar } from "../../store/site/actions";

const PageHeader = props => (
  <header className="page-header">
    <h1>{props.title}</h1>
    <Button
      className="ml-auto open-menu"
      outline
      color="primary"
      onClick={() => props.dispatch(toggleSidebar(true))}
    >
      Menu
    </Button>
  </header>
);

export default connect()(PageHeader);



// WEBPACK FOOTER //
// ./src/system/components/PageHeader/index.jsx